import { hasActiveSession } from 'app/modules';
import sessionEvents from 'events/session';

export default function handleTypingStart(isAgentTyping) {
  return (dispatch, getState) => {
    if (!hasActiveSession(getState())) {
      return;
    }

    dispatch(sessionEvents.sessionUpdateSuccess({ isAgentTyping }));
  };
}
